<template>
  <!-- <v-locale-provider rtl> -->
  <v-textarea
    v-bind="$attrs"
    v-on="$listeners"
    dir="rtl"
    class="text-right dhivehi"
    outlined
    :readonly="disabled"
    rows="1"
    auto-grow
  ></v-textarea>
  <!-- </v-locale-provider> -->
</template>

<script>
export default {
  props: ['disabled'],
}
</script>